module.exports = __webpack_public_path__ + "static/media/logoheader.0476e8d1.png";